// Reviews button scroll functionality
document.addEventListener('DOMContentLoaded', function() {
  const reviewButtons = document.querySelectorAll('.reviews-btn');
  
  reviewButtons.forEach(function(button) {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      const reviewsSection = document.querySelector('.okeReviews');
      
      if (reviewsSection) {
        reviewsSection.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
});

// Size Guide Modal
document.addEventListener('DOMContentLoaded', function() {
  const sizeGuideButton = document.querySelector('.size-guide-link');
  
  if (sizeGuideButton) {
    sizeGuideButton.addEventListener('click', function(e) {
      e.preventDefault();
      
      const sizeGuideModal = document.querySelector('#sizeGuideModal');
      if (sizeGuideModal) {
        const details = sizeGuideModal.querySelector('details');
        if (details) {
          details.open = true;
          document.body.classList.add('overflow-hidden');
        }
      }
    });
  }
});

// Modal close button functionality for all modals
document.addEventListener('DOMContentLoaded', function() {
  const closeButtons = document.querySelectorAll('.modal__close-button');
  
  closeButtons.forEach(function(button) {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // Find the parent details-modal element
      const modal = button.closest('details-modal');
      if (modal) {
        const details = modal.querySelector('details');
        if (details) {
          details.open = false;
          document.body.classList.remove('overflow-hidden');
        }
      }
    });
  });
});

// Product Availability Check
document.addEventListener('DOMContentLoaded', function() {
    let isInitialized = false;
    let observer = null;

    // Clean up URL after form submission to prevent inventory app errors
    if (window.location.search.includes('contact_posted=true')) {
        // Open the price match modal to show success message
        const priceMatchModal = document.querySelector('#priceMatchModal');
        if (priceMatchModal) {
            const details = priceMatchModal.querySelector('details');
            if (details) {
                details.open = true;
                document.body.classList.add('overflow-hidden');
            }
        }
        
        // Remove the query parameter without reloading the page
        const cleanUrl = window.location.pathname + window.location.hash;
        window.history.replaceState({}, document.title, cleanUrl);
    }

    // Listen for variant changes to show/hide check inventory button
    document.addEventListener('on:variant:change', function(e) {
        console.log('Variant changed:', e.detail);
        
        const productInventory = document.querySelector('product-inventory');
        if (!productInventory) return;
        
        const checkInventoryBtn = productInventory.querySelector('.check-inventory');
        const separator = productInventory.querySelector('.product-inventory__status-separator');
        
        console.log('Button found:', checkInventoryBtn);
        console.log('Variant available:', e.detail?.variant?.available);
        
        if (checkInventoryBtn && separator) {
            if (e.detail && e.detail.variant && e.detail.variant.available) {
                checkInventoryBtn.classList.remove('hidden');
                separator.classList.remove('hidden');
            } else {
                checkInventoryBtn.classList.add('hidden');
                separator.classList.add('hidden');
            }
        }
    });

    // Close modal handler for inventory modal
    document.addEventListener('click', function(e) {
        // Close button or backdrop click for inventory modal
        if (e.target.closest('.modal__close-button') && e.target.closest('#inventoryModal') || 
            (e.target.classList.contains('modal') && e.target.classList.contains('modal--inventory'))) {
            const modal = document.querySelector('#inventoryModal');
            if (modal) {
                const details = modal.querySelector('details');
                if (details && details.open) {
                    details.open = false;
                    document.body.classList.remove('overflow-hidden');
                }
            }
        }
        
        // Close button or backdrop click for price match modal
        if (e.target.closest('.modal__close-button') && e.target.closest('#priceMatchModal') || 
            (e.target.classList.contains('modal') && e.target.classList.contains('modal--price-match'))) {
            const modal = document.querySelector('#priceMatchModal');
            if (modal) {
                const details = modal.querySelector('details');
                if (details && details.open) {
                    details.open = false;
                    document.body.classList.remove('overflow-hidden');
                }
            }
        }
    });

    // Click handler for price-match button
    document.addEventListener('click', function(e) {
        if (e.target.closest('.price-match')) {
            e.preventDefault();
            
            console.log('Price match clicked');
            
            // Open the modal
            const modal = document.querySelector('#priceMatchModal');
            console.log('Price match modal found:', modal);
            
            if (modal) {
                const details = modal.querySelector('details');
                if (details && !details.open) {
                    details.open = true;
                    document.body.classList.add('overflow-hidden');
                    console.log('Price match modal opened');
                    
                    // Populate hidden fields with product info
                    const productTitle = document.querySelector('.product__title, .product-title, h1')?.textContent.trim() || '';
                    const productUrl = window.location.href;
                    
                    // Get SKU
                    let sku = '';
                    const skuElement = document.querySelector('[data-sku], .product-sku, .sku');
                    if (skuElement) {
                        sku = skuElement.textContent.trim() || skuElement.dataset.sku || '';
                    }
                    
                    // Get current price
                    let price = '';
                    const priceElement = document.querySelector('.price__current, .price .money, [data-price]');
                    if (priceElement) {
                        price = priceElement.textContent.trim();
                        // Remove "Sale price", "Regular price", and extra whitespace
                        price = price.replace(/Sale price/gi, '')
                                     .replace(/Regular price/gi, '')
                                     .replace(/\s+/g, ' ')
                                     .trim();
                    }
                    
                    // Get selected variant info
                    let variantInfo = '';
                    const variantPicker = document.querySelector('variant-picker');
                    if (variantPicker) {
                        const checkedInputs = variantPicker.querySelectorAll('input:checked');
                        const selects = variantPicker.querySelectorAll('select');
                        
                        let values = [];
                        checkedInputs.forEach(input => values.push(input.value || input.textContent));
                        selects.forEach(select => {
                            if (select.selectedOptions && select.selectedOptions.length > 0) {
                                values.push(select.selectedOptions[0].textContent);
                            }
                        });
                        
                        variantInfo = values.join(' / ');
                    }
                    
                    // Build product info string
                    let productInfoParts = [];
                    
                    // Add product name
                    if (productTitle) {
                        productInfoParts.push(productTitle);
                    }
                    
                    // Add variant if exists
                    if (variantInfo) {
                        productInfoParts.push(variantInfo);
                    }
                    
                    // Add SKU if exists
                    if (sku) {
                        productInfoParts.push('SKU: ' + sku);
                    }
                    
                    // Add price if exists
                    if (price) {
                        productInfoParts.push(price);
                    }
                    
                    // Add page URL
                    productInfoParts.push(productUrl);
                    
                    const productInfoText = productInfoParts.join(' -- ');
                    
                    // Set visible readonly field
                    const productInfoField = document.getElementById('pm_product_info');
                    if (productInfoField) {
                        productInfoField.value = productInfoText;
                    }
                    
                    // Set hidden field values
                    document.getElementById('pm_product_title').value = productTitle;
                    document.getElementById('pm_product_url').value = productUrl;
                    document.getElementById('pm_product_variant').value = variantInfo || 'Default';
                }
            }
        }
    });

    // Click handler for check-inventory button
    document.addEventListener('click', function(e) {
        if (e.target.classList.contains('check-inventory')) {
            e.preventDefault();
            
            console.log('Check inventory clicked');
            
            // Open the modal
            const modal = document.querySelector('#inventoryModal');
            console.log('Modal found:', modal);
            
            if (modal) {
                const details = modal.querySelector('details');
                if (details && !details.open) {
                    details.open = true;
                    document.body.classList.add('overflow-hidden');
                    console.log('Modal opened');
                }
            }
            
            // Initialize inventory check if not already done
            if (!isInitialized) {
                console.log('Initializing product availability');
                productAvailability();
                isInitialized = true;
            } else {
                console.log('Already initialized, updating inventory');
                // If already initialized, just update the display
                runInventory();
            }
            
            // Add a small delay to ensure modal is rendered, then try to populate
            setTimeout(function() {
                console.log('Running inventory after delay');
                runInventory();
            }, 100);
        }
    });

    function productAvailability() {
        let retryCount = 0;

        function waitForInventoryList() {
            const container = document.querySelector("#tomit_inventory_list");
            const liElements = container ? container.querySelectorAll("li") : null;

            console.log('container here', container);
            console.log('tomit_inventory_list here', liElements);

            if (liElements && liElements.length > 0) {
                console.log('Inventory list found, setting up observer');

                // Once #tomit_inventory_list is found, set up the MutationObserver
                observer = new MutationObserver(function(mutations) {
                    console.log("Mutation observed:", mutations);
                    runInventory();
                });

                observer.observe(container, {
                    subtree: true,
                    childList: true,
                    attributes: true
                });

                console.log('Observer started!');
                
                // Run inventory display immediately
                runInventory();
            } else {
                retryCount++;

                if (retryCount >= 20) {
                    console.log('Retry limit reached, stopping check.');
                    return;
                }

                setTimeout(waitForInventoryList, 500);
            }
        }

        waitForInventoryList();
    }

    // Make runInventory available in outer scope
    function runInventory() {
        console.log('runInventory called');
        
        // Get the current selected variant
        const variantPicker = document.querySelector('variant-picker');
        let selectedVariant = '';
        
        if (variantPicker) {
            const values = [];

            variantPicker.querySelectorAll('.option-selector').forEach(optionSelector => {
                const checkedInput = optionSelector.querySelector('input:checked');
                if (checkedInput) {
                    values.push(checkedInput.value || checkedInput.textContent);
                    return;
                }

                const select = optionSelector.querySelector('select');
                if (select && select.selectedOptions && select.selectedOptions.length > 0) {
                    values.push(select.selectedOptions[0].textContent);
                    return;
                }

                const customSelectOption = optionSelector.querySelector('.custom-select__option[aria-selected="true"]');
                if (customSelectOption) {
                    values.push(customSelectOption.dataset.value || customSelectOption.textContent.trim());
                }
            });

            selectedVariant = values.join(' / ');
        }

        const variantDisplay = document.querySelector('#inventoryModal .product-variant');
        console.log('Variant display element:', variantDisplay);
        if (variantDisplay) {
            variantDisplay.textContent = selectedVariant || 'Default';
        }

        reformatLocations();
    }

    // Make reformatLocations available in outer scope
    function reformatLocations() {
        const ul = document.querySelector('#tomit_inventory_list');
        const display = document.querySelector('#inventoryLocationInformationDisplay');

        console.log('reformatLocations called');
        console.log('ul:', ul);
        console.log('display:', display);

        if (!ul || !display) {
            console.log('Required elements not found', {ul, display});
            return;
        }

        const liElements = ul.querySelectorAll('li');
        console.log('Found li elements:', liElements.length);
        
        let data = [];
        let html = '';

        liElements.forEach(function(li, index) {
            console.log(`Processing li ${index}:`, li);
            console.log('Li innerHTML:', li.innerHTML);
            
            // Try multiple selectors to find location name
            let name = li.querySelector('.location')?.textContent.trim() || 
                       li.querySelector('[class*="location"]')?.textContent.trim() ||
                       li.querySelector('span:first-child')?.textContent.trim() ||
                       li.textContent.split(/\n/)[0]?.trim() || '';
            
            // Try multiple selectors to find stock level
            let stockLevel = li.querySelector('.stockCount span')?.textContent.trim() ||
                            li.querySelector('.stockCount')?.textContent.trim() ||
                            li.querySelector('[class*="stock"]')?.textContent.trim() ||
                            li.querySelector('span:last-child')?.textContent.trim() || '';

            console.log(`Location: "${name}", Stock: "${stockLevel}"`);

            if (name) {
                data.push({
                    loc: name,
                    stock: stockLevel
                });
            }
        });

        console.log('HH location data ', data);

        if (data.length === 0) {
            display.innerHTML = '<p>This product is not available in any stores at this time.</p>';
            return;
        }

        // Start building table HTML
        html = '<table class="inventory-table"><thead><tr><th>Store Location</th><th>Stock Level</th></tr></thead><tbody>';

        // Loop through data to generate table rows
        data.forEach(function(area) {
            let type = 'red';
            let trimmedStock = area.stock.trim();

            // Check for various stock level formats
            if (trimmedStock.toLowerCase().includes('high') || trimmedStock.toLowerCase().includes('in stock')) {
                type = 'green';
            } else if (trimmedStock.toLowerCase().includes('low')) {
                type = 'orange';
            } else if (trimmedStock.toLowerCase().includes('out')) {
                type = 'red';
            } else if (parseInt(trimmedStock) > 5) {
                type = 'green';
            } else if (parseInt(trimmedStock) > 0) {
                type = 'orange';
            }

            html += '<tr>';
            html += `<td class="stores">${area.loc}</td>`;
            let displayStock = area.stock || 'Check with store';
            // Replace 'High Stock' with 'In Stock'
            if (displayStock.toLowerCase().includes('high stock')) {
                displayStock = 'In Stock';
            }
            html += `<td><span class="stock ${type}">${displayStock}</span></td>`;
            html += '</tr>';

            console.log('area stock type', area.stock, type);
        });

        html += '</tbody></table>';

        display.innerHTML = html;
        console.log('Display updated with HTML');
    }
});



document.addEventListener('DOMContentLoaded', function() {
    const wishlistButton = document.querySelector('.my-custom-wishlist-button');
    
    if (wishlistButton) {
        wishlistButton.addEventListener('click', function(e) {
            e.preventDefault();
            
            const productId = this.getAttribute('data-product-id');
            const variantId = this.getAttribute('data-variant-id');
            const productUrl = this.getAttribute('data-product-url');
            
            // Add to wishlist using Swym
            if (typeof _swat !== 'undefined') {
                _swat.addToWishlist({
                    epi: productId,
                    empi: variantId,
                    du: productUrl
                });
            }
        });
    }
});

// Product rating scroll functionality
document.addEventListener('DOMContentLoaded', function() {
  const ratingElement = document.querySelector('.product-info__rating');
  
  console.log('Rating element found:', ratingElement);
  
  if (ratingElement) {
    ratingElement.addEventListener('click', function(e) {
      console.log('Product rating clicked!');
      e.preventDefault();
      
      const reviewsSection = document.querySelector('.okeReviews');
      console.log('Reviews section found:', reviewsSection);
      
      if (reviewsSection) {
        console.log('Scrolling to reviews section');
        reviewsSection.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        });
      } else {
        console.log('Reviews section not found');
      }
    });
  } else {
    console.log('Rating element not found on page load');
  }
});

// Strip href from shipping info link and open modal popup instead
document.addEventListener('DOMContentLoaded', function() {
  var links = document.querySelectorAll('.get-help-disclosure-content a');
  for (var i = 0; i < links.length; i++) {
    var text = links[i].textContent.trim().toLowerCase();
    if (text.indexOf('shipping') !== -1) {
      links[i].removeAttribute('href');
      links[i].style.cursor = 'pointer';
    }
  }
});

document.addEventListener('click', function(e) {
  var getHelp = e.target.closest('.get-help-disclosure-content');
  if (!getHelp) return;

  var link = e.target.closest('a');
  var target = link || e.target;
  var text = target.textContent.trim().toLowerCase();
  if (text.indexOf('shipping') === -1) return;

  e.preventDefault();
  e.stopPropagation();

  var modal = document.querySelector('#shippingPolicyModal');
  if (modal && modal.open) {
    modal.open();
  }
});

// Gem Popup Trigger
document.addEventListener('DOMContentLoaded', function() {
  const gemPopupTriggers = document.querySelectorAll('.gem-popup-trigger');
  const gemPopupModal = document.querySelector('#gemPopupModal');
  
  if (gemPopupTriggers.length > 0 && gemPopupModal) {
    const details = gemPopupModal.querySelector('details');
    
    gemPopupTriggers.forEach(function(trigger) {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        if (details) {
          details.open = true;
          document.body.classList.add('overflow-hidden');
          
          // Trap focus in modal
          if (window.trapFocus) {
            window.trapFocus(details);
          }
        }
      });
    });
    
    // Close button handler
    const closeButton = gemPopupModal.querySelector('.modal__close-button');
    if (closeButton) {
      closeButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        if (details) {
          details.open = false;
          document.body.classList.remove('overflow-hidden');
          
          if (window.removeTrapFocus) {
            window.removeTrapFocus();
          }
        }
      });
    }
    
    // Close on backdrop click
    const modal = gemPopupModal.querySelector('.modal');
    if (modal) {
      modal.addEventListener('click', function(e) {
        if (e.target === modal) {
          if (details) {
            details.open = false;
            document.body.classList.remove('overflow-hidden');
            
            if (window.removeTrapFocus) {
              window.removeTrapFocus();
            }
          }
        }
      });
    }
    
    // Close on Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && details && details.open) {
        details.open = false;
        document.body.classList.remove('overflow-hidden');
        
        if (window.removeTrapFocus) {
          window.removeTrapFocus();
        }
      }
    });
  }
});


